import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from 'app/store';
import IContact from 'app/models/Contact';

export const selectContact = (state:RootState) => state[Reducers.Contacts].contact;
export const selectContacts = (state:RootState) => state[Reducers.Contacts].contacts;
export const selectAutocomplete = (state:RootState) => state[Reducers.Contacts].autocomplete;
export const selectTotal = (state:RootState) => state[Reducers.Contacts].total;
export const selectParams = (state:RootState) => state[Reducers.Contacts].params;
export const selectFilters = (state:RootState) => state[Reducers.Contacts].filters;
export const selectLoading = (state:RootState) => state[Reducers.Contacts].loading;
export const selectAutocompleteLoading = (state:RootState) => state[Reducers.Contacts].autocompleteLoading;

export const selectContactsAsOptions = createSelector(
  [ selectAutocomplete ],
  (contacts:IContact[] | null) => {
    if ( !contacts ) return null;
    return contacts.map((contact:IContact) => ({
      id: contact.id,
      name: contact.name,
      props: {
        type: contact.type,
        address: contact.address,
        referenceContact: contact.referenceContact
      }
    }));
  }
);
